import {
  Button,
  CheckBox,
  CheckBoxGroup,
  DatePicker,
  Icon,
  RaytebForm,
  Select,
  TextBox,
  TypeaheadText,
} from '../../Elements'
import { TextBoxTypeEnum } from '../../../enums/TextBoxTypeEnum'
import RaytebModal from './RaytebModal'
import useFetch from '../../../_services/fetch'
import { RaytebRequests } from '../../../_services'
import { useSelector } from 'react-redux'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import LoadingFit from '../Loading/LoadingFit'
import { useState } from 'react'
import Debounce from '../../Elements/Textboxs/Debounce'
import { toast } from 'react-toastify'

type VisitTimeType = {
  title: string
  selected: boolean
  index: number
}
type TimeType = {
  fromTime: string
  toTime: string
}
const InsertDoctorTimeSheetModal = ({
  options,
  onSuccess,
}: {
  options: RaytebModalInterface
  onSuccess?: () => void
}) => {
  var items: { [id: string]: CheckBoxInterface } = {
    ['0']: { lable: 'شنبه' },
    ['1']: { lable: 'یکشنبه' },
    ['2']: { lable: 'دوشنبه' },
    ['3']: { lable: 'سه شنبه' },
    ['4']: { lable: 'چهارشنبه' },
    ['5']: { lable: 'پنج شنبه' },
    ['6']: { lable: 'جمعه' },
  }
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const getDoctorServes = useFetch<Array<DoctorServeViewModel>, unknown>({
    request: RaytebRequests.Doctor_GetDoctorServe_GET({
      centerId: center.id!,
      token: user.token,
    }),
    fetchInitialLoad: true,
  })
  const [doctorServe, setDoctorServe] = useState<DoctorServeViewModel | null>(
    null
  )
  const [listTimeVips, setListTimeVips] = useState<Array<VisitTimeType>>([])
  const [listTimeRefs, setListTimeRefs] = useState<Array<VisitTimeType>>([])
  const [startRef, setStartRef] = useState<number>(1)
  const [visitTime, setVisitTime] = useState<TimeType>({
    fromTime: '',
    toTime: '',
  })
  const [restTime, setRestTime] = useState<TimeType>({
    fromTime: '',
    toTime: '',
  })

  const createDoctorTimeSheet = useFetch<
    unknown,
    DoctorTimeSheetCreateInputModel
  >({
    request: RaytebRequests.DoctorTimeSheet_Create_Post({
      centerId: center.id!,
      token: user.token,
    }),
    onSuccess(data) {
      options.hideModal?.()
      toast.success('با موفقیت انجام شد')
      onSuccess?.()
      setDefault()
    },
  })
  const setDefault = () => {
    setListTimeVips([])
    setListTimeRefs([])
    setStartRef(1)
    setVisitTime({
      fromTime: '',
      toTime: '',
    })
    setRestTime({
      fromTime: '',
      toTime: '',
    })
  }
  const calcDate = (date1: Date, date2: Date): number => {
    var diff = Math.floor(date1.getTime() - date2.getTime())
    var min = 1000 * 60

    var minutes = Math.floor(diff / min)

    return minutes
  }
  const getTimes = (
    cap: number,
    fromTimeParam: string,
    toTimeParam: string,
    toTimeRestParam?: string,
    fromTimeRestParam?: string
  ): Array<VisitTimeType> => {
    const splitToTime = toTimeParam.split(':')
    const splitFromTime = fromTimeParam.split(':')
    const splitToTimeRest = toTimeRestParam?.split(':') ?? []
    const splitFromTimeRest = fromTimeRestParam?.split(':') ?? []
    const fromTime = new Date()
    fromTime.setHours(parseInt(splitFromTime[0]))
    fromTime.setMinutes(parseInt(splitFromTime[1]))
    const toTime = new Date()
    toTime.setHours(parseInt(splitToTime[0]))
    toTime.setMinutes(parseInt(splitToTime[1]))
    const toTimeRest = new Date()
    const fromTimeRest = new Date()

    if (toTimeRestParam && fromTimeRestParam) {
      toTimeRest.setHours(parseInt(splitToTimeRest?.[0] ?? 0))
      toTimeRest.setMinutes(parseInt(splitToTimeRest?.[1] ?? 0))
      fromTimeRest.setHours(parseInt(splitFromTimeRest[0]))
      fromTimeRest.setMinutes(parseInt(splitFromTimeRest[1]))
    }
    const dVisitMin = calcDate(toTime, fromTime)
    const dRestMin = calcDate(toTimeRest, fromTimeRest)


    const someTime = Math.round((dVisitMin - dRestMin) / cap)

    var times = Array<VisitTimeType>()
    times.push({
      title: `${('0' + fromTime.getHours()).substr(-2)}:${('0' + fromTime.getMinutes()).substr(-2)}`,
      selected: false,
      index: times.length + 1,
    })

    var index = 1
    var resultTime;
    while (times.length < cap) {
      const calTime = new Date(resultTime ?? fromTime)
      calTime.setMinutes(calTime.getMinutes() + (index * someTime))
      if (
        calTime >= fromTimeRest &&
        calTime <= toTimeRest
      ) {
        resultTime = toTimeRest;
        index = 1;
        addTime(resultTime, times);
        continue;
        // index += someTimeRest;
      }
      addTime(calTime, times);
      index += 1
    }
    return times
  }
  const addTime = (calTime: Date, times: Array<VisitTimeType>) => {
    const hour = '0' + calTime.getHours()
    const min = '0' + calTime.getMinutes()
    times.push({
      title: `${hour.substr(-2)}:${min.substr(-2)}`,
      selected: false,
      index: times.length + 1,
    })
  }
  const generateTimes = (fromTime, toTime) => {
    if (fromTime && toTime) {
      var cap = document.getElementById('Capacity') as HTMLInputElement
      setListTimeVips(
        getTimes(
          parseInt(cap.value),
          fromTime,
          toTime,
          restTime.toTime,
          restTime.fromTime
        )
      )
      setListTimeRefs(
        getTimes(
          parseInt(cap.value),
          fromTime,
          toTime,
          restTime.toTime,
          restTime.fromTime
        )
      )
    }
  }
  return (
    <RaytebModal
      {...options}
      hideModal={() => {
        setDefault()
        options.hideModal?.()
      }}
    >
      <LoadingFit
        isLoading={getDoctorServes.isLoading || createDoctorTimeSheet.isLoading}
      />
      <RaytebForm
        checkIsRequired={true}
        onSubmit={(e) => {
          createDoctorTimeSheet.reFetch({
            capacity: e.target['capacity'].value,
            fromDate: e.target['fromDate'].getAttribute('rayteb-value'),
            toDate: e.target['toDate'].getAttribute('rayteb-value'),
            fromTimeRest:
              e.target['fromTimeRest'].value === '__:__'
                ? null
                : e.target['fromTimeRest'].value,
            toTimeRest:
              e.target['toTimeRest'].value === '__:__'
                ? null
                : e.target['toTimeRest'].value,
            shift: e.target['shift'].value,
            days: e.target['days'].getAttribute('rayteb-value'),
            fromTimeVisit: e.target['fromTime'].value,
            toTimeVisit: e.target['toTime'].value,
            refStartDay: e.target['fromDayRef'].value,
            refExpireDay: e.target['toDayRef'].value,
            vipItemList: listTimeVips
              .filter((n) => n.selected)
              .map((n) => n.index)
              .toString(),
            refItemList: listTimeRefs
              .filter((n) => n.selected)
              .map((n) => n.index)
              .toString(),
            doctorServeId: doctorServe?.id!,
          })
        }}
      >
        <div className='grid grid-cols-2 gap-x-6 gap-y-8 px-6 py-8'>
          <CheckBoxGroup items={items} name='days' lable='همه روز ها' />
          <Select className='w-full' name='shift' isRequired={true}>
            <option value={''}>انتخاب شیفت</option>
            <option value={1}>شیفت صبح</option>
            <option value={2}>شیفت ظهر</option>
            <option value={3}>شیفت شب</option>
          </Select>
          <TypeaheadText<DoctorServeViewModel>
            innerText='خدمت'
            fieldItem='title'
            fieldValue='id'
            selected={(e) => setDoctorServe(e)}
            listData={getDoctorServes.result}
            isRequired={true}
          ></TypeaheadText>
          <TextBox
            Type={TextBoxTypeEnum.Number}
            innerText='تعداد ظرفیت'
            className='w-full'
            onChange={(e) => {
              var toTime = document.getElementById('ToTime') as HTMLInputElement
              var fromTime = document.getElementById(
                'FromTime'
              ) as HTMLInputElement
              if (toTime.value != '__:__' && fromTime.value != '__:__') generateTimes(fromTime.value, toTime.value)
            }}
            name='capacity'
            id='Capacity'
            isRequired={true}
          />
          <DatePicker
            isRequired={true}
            name='fromDate'
            innerText='تاریخ شروع'
            className='w-full'
          />
          <DatePicker
            isRequired={true}
            name='toDate'
            innerText='تاریخ پایان'
            className='w-full'
          />
          <TextBox
            className='w-full'
            isRequired={true}
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage='از 00:00 تا 23:59'
            innerText='ساعت شروع'
            name='fromTime'
            id='FromTime'
            debounceTime={0}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.toTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.toTime.split(':')[1]))

              if (date >= time) {
                toast.error(
                  'ساعت شروع  نمیتواند بزرگتر و مساوی ساعت پایان باشد'
                )
                return
              }
              setVisitTime({ ...visitTime, fromTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(e.target.value, visitTime.toTime)
            }}

            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            isRequired={true}
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage='از 00:00 تا 23:59'
            className='w-full'
            innerText='ساعت پایان'
            name='toTime'
            id='ToTime'
            debounceTime={0}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.fromTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.fromTime.split(':')[1]))

              if (date <= time) {
                toast.error(
                  'ساعت پایان  نمیتواند کوچک تر و مساوی ساعت شروع باشد'
                )
                return
              }

              setVisitTime({ ...visitTime, toTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(visitTime.fromTime, e.target.value)
            }}

            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            className='w-full'
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage={`از ${visitTime.fromTime} تا ${visitTime.toTime}`}
            innerText='شروع استراحت'
            disabled={!visitTime.fromTime}
            name='fromTimeRest'
            id='FromTimeRest'
            debounceTime={0}
            value={restTime.fromTime}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.fromTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.fromTime.split(':')[1]))

              if (date <= time) {
                toast.error(
                  'ساعت شروع استراحت نمیتواند کوچک تر و مساوی ساعت شروع باشد'
                )
                return
              }

              setRestTime({ ...restTime, fromTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(visitTime.fromTime, visitTime.toTime)
            }}
            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            Regular='^(([01]?[0-9]|2[0-3]):[0-5][0-9]){1,5}$'
            RxgMessage={`از ${visitTime.fromTime} تا ${visitTime.toTime}`}
            className='w-full'
            innerText='پایان استراحت'
            disabled={!visitTime.toTime}
            name='toTimeRest'
            value={restTime.toTime}
            id='ToTimeRest'
            debounceTime={0}
            onChange={(e) => {
              var date = new Date()
              date.setHours(parseInt(e.target.value.split(':')[0]))
              date.setMinutes(parseInt(e.target.value.split(':')[1]))
              var time = new Date()
              time.setHours(parseInt(visitTime.toTime.split(':')[0]))
              time.setMinutes(parseInt(visitTime.toTime.split(':')[1]))

              if (date >= time) {
                toast.error(
                  'ساعت شروع استراحت نمیتواند بزرگ تر و مساوی ساعت شروع باشد'
                )
                return
              }
              setRestTime({ ...restTime, toTime: e.target.value })
              var cap = document.getElementById('Capacity') as HTMLInputElement
              if (cap.value) generateTimes(visitTime.fromTime, visitTime.toTime)
            }}

            Type={TextBoxTypeEnum.Time}
          />
          <TextBox
            Type={TextBoxTypeEnum.Number}
            name='fromDayRef'
            isRequired={true}
            value={startRef.toString()}
            onChange={(e) => setStartRef(e.target.value)}
            Regular='^(([0-9][0-4])|([1-9]))$'
            msgValidate='شروع ارجاع باید بین 1 تا 14 باشد'
            innerText='شروع ارجاع'
            className='w-full'
          />
          <TextBox
            Type={TextBoxTypeEnum.Number}
            name='toDayRef'
            value='0'
            innerText='پایان ارجاع'
            className='w-full'
            onChange={(e) => {
              if (
                parseInt(e.target.value) >= startRef ||
                parseInt(e.target.value) < 0
              )
                toast.error(`پایان ارجاع باید بین 0 تا ${startRef - 1} باشد`)
            }}
          />
        </div>
        <div className='w-full mt-2 flex justify-between items-center'>
          <div className='flex px-4 gap-1 items-center'>
            <Icon
              icon='rayteb-history-track'
              className='w-6 h-6 text-2xl text-primaryLight'
            />
            <span className='text-xs'>تیکت های VIP</span>
          </div>
          <div>
            <CheckBox
              disabled={listTimeVips.length === 0}
              id='ListTimeVipsCheck'
              onChange={(e) => {
                var list = [...listTimeVips]
                list.forEach((n, i) => {
                  if (!listTimeRefs[i].selected) n.selected = e.target.checked
                })
                setListTimeVips(list)

                if (
                  (
                    document.getElementById(
                      'ListTimeRefsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeRefs]
                  list.forEach((n, i) => {
                    if (!listTimeVips[i].selected) n.selected = true
                  })
                  setListTimeRefs(list)
                }
              }}
              lable='انتخاب همه'
              className='text-primaryLight text-xs'
            />
          </div>
        </div>

        <div className='grid grid-cols-6 gap-3  px-3 py-2'>
          {listTimeVips?.map((n, i) => (
            <Button
              key={i}
              onClick={() => {
                if (listTimeRefs[i].selected) {
                  toast.error('این زمان ارجاع میباشد')
                  return
                }
                var list = [...listTimeVips]
                list[i].selected = !list[i].selected
                setListTimeVips(list)
                if (
                  (
                    document.getElementById(
                      'ListTimeRefsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeRefs]
                  list.forEach((n, i) => {
                    if (!listTimeVips[i].selected) n.selected = true
                  })
                  setListTimeRefs(list)
                }
              }}
              className={`text-primaryLight bg-primaryDefault border-0 h-5 text-xs 
               ${n.selected
                  ? '!bg-warn !text-primaryDefault2 shadow-warnDark shadow-inner'
                  : 'font-bold'
                }`}
            >
              {`${n.title.toPersian()}`}
            </Button>
          ))}
        </div>

        <div className='w-full mt-3 flex justify-between items-center'>
          <div className='flex px-4 gap-1 items-center'>
            <Icon
              icon='rayteb-history-track'
              className='w-6 h-6 text-2xl text-primaryLight'
            />
            <span className='text-xs'>تیکت های ارجاع</span>
          </div>
          <div>
            <CheckBox
              disabled={listTimeRefs.length === 0}
              id='ListTimeRefsCheck'
              onChange={(e) => {
                var list = [...listTimeRefs]
                list.forEach((n, i) => {
                  if (!listTimeVips[i].selected) n.selected = e.target.checked
                })
                setListTimeRefs(list)

                if (
                  (
                    document.getElementById(
                      'ListTimeVipsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeVips]
                  list.forEach((n, i) => {
                    if (!listTimeRefs[i].selected) n.selected = true
                  })
                  setListTimeVips(list)
                }
              }}
              lable='انتخاب همه'
              className='text-primaryLight text-xs'
            />
          </div>
        </div>

        <div className='grid grid-cols-6 gap-3  px-3 py-2'>
          {listTimeRefs.map((n, i) => (
            <Button
              onClick={() => {
                if (listTimeVips[i].selected) {
                  toast.error('این زمان وی آی پی میباشد')
                  return
                }
                var list = [...listTimeRefs]
                list[i].selected = !list[i].selected
                setListTimeRefs(list)
                if (
                  (
                    document.getElementById(
                      'ListTimeVipsCheck'
                    ) as HTMLInputElement
                  ).checked
                ) {
                  var list = [...listTimeVips]
                  list.forEach((n, i) => {
                    if (!listTimeRefs[i].selected) n.selected = true
                  })
                  setListTimeVips(list)
                }
              }}
              key={i}
              className={`text-primaryLight bg-primaryDefault border-0 h-5 text-xs 
               ${n.selected
                  ? '!bg-secondaryLight !text-primaryDefault2 shadow-secondary shadow-inner'
                  : 'font-bold'
                }`}
            >
              {`${n.title.toPersian()}`}
            </Button>
          ))}
        </div>

        <div className='mt-4 flex justify-center items-center px-6 pb-3 gap-10 w-full'>
          <Button
            type='button'
            onClick={() => {
              setDefault()
              options.hideModal?.()
            }}
            className='!border-2 border-dangerLight !bg-danger !text-white
             !text-xs !w-full h-9 !shadow-lg'
          >
            انصراف
          </Button>
          <Button
            type='submit'
            className='!border-2 border-secondaryLight !bg-secondary !text-white
             !text-xs !w-full h-9 !shadow-lg'
          >
            تایید
          </Button>
        </div>
      </RaytebForm>
    </RaytebModal>
  )
}

export default InsertDoctorTimeSheetModal
